import { useContext } from 'react';
import { CotizadorContext } from '../context';

const useErrorNotification = () => {
    const [state, setState] = useContext(CotizadorContext);

    const showError = (message) => {
        setState(prevState => ({
            ...prevState,
            error_notification: message
        }));
    };

    const clearError = () => {
        setState(prevState => ({
            ...prevState,
            error_notification: null
        }));
    };

    return {
        error_notification: state.error_notification,
        showError,
        clearError
    };
};

export default useErrorNotification;
